// extracted by mini-css-extract-plugin
module.exports = {"messages":"Messages-messages-3BLtH"};